const CONSTANTS ={
    // APIBASEURL : 'https://fortune-homecare.herokuapp.com/',
    APIBASEURL : 'https://api.fortunehomecare.com/',
    TYNYAPIKEY : "0v0a5m4g0aiec6pr65g9jrr231ojdi4wl36sms4rnczgcof6",
    APIURL:{
        GetIp:'https://api.ipify.org?format=json',
        Login:'auth/admin/login',
        Logout:'auth/admin/logout',
        ForgotPassword:'auth/admin/forgot-password',
        ResetPassword:'auth/admin/reset-password',  
        ChangePassword:'auth/admin/change-password',
        UpdateFCMToken:'auth/admin/update/device-token/',
        MyPermissions:'sub-admin/my-permissions/',

        Dashboard : "dashboard",

        // Sub Admin
        SubAdmin : "sub-admin/",
        SubAdminPermissions : "sub-admin/permissions",

        // Service Modules
        ServiceCategory : "services/category/",

        ServiceCreate : "services/create",
        ListServices : "services/list?limit=6&q=",
        ServiceDetail : "services/detail/",
        ServiceUpdate : "services/update/",
        ServiceDestroy : "services/destroy/",

        //FAQ
        FAQ : "help/faq/",

        //Packages
        ServicePackages : "packages/",

        // IssueTickets
        ListIssueTickets : "help/issue-tickets/?limit=4",
        IssueTickets : "help/issue-tickets/",
        RetrieveTicket : "help/issue-tickets/",
        FilterTickets : "help/list-filters",

        // Vendors
        Vendors : "vendors/business-details/",
        BusinessEmployees : "vendors/employees/",
        VendorServices : "vendors/services/",
        RelatedVendors : "bookings/related-vendors?booking=",
        ListAllVendors : "bookings/list-all-vendors",
        AssignVendor : "bookings/assign-vendor/",
        ListAllServices:"services/list-all",

        //Audits
        Audits : "bookings/list-all-audits",
        RetrieveAudit : "bookings/retrieve-audit/",
        CancelAudit : "bookings/superuser/cancel-audit/",

        //Bookings
        Bookings : "bookings/list-all-bookings",
        RetrieveBooking : "bookings/retrieve-booking/",
        CancelBooking : "bookings/superuser/cancel-booking/",
        ListStatus:'bookings/list-status',

        //Reviews
        Reviews : "reviews/all/?q=",

        // Payments
        PayIns : "payments/list-all-payins?limit=10&q=",
        PayOuts : "payments/list-all-payouts?limit=10&vendor=",

         // Users
         Users : "auth/admin/users",
         DeactivateUsers : "auth/admin/destroy-user/",

    }
}

export default CONSTANTS